import {
  ADD_TASK_LABEL,
  REMOVE_TASK_LABEL,
  UPDATE_TASK_LABEL,
  SET_LABEL_FILTERS,
  SET_MINDSET,
  SET_SORT_ORDER,
  SET_TASK_LABELS,
  SET_USER,
  SET_USER_AUTHENTICATED,
  SET_AUTH_STATE,
  SET_LOADING_USER,
  SET_USER_SUBSCRIPTION,
  SET_MESSAGES,
  SET_TASK_CREATION_PREFERENCE,
} from "../constants/user";

export const setUser = (user) => ({ type: SET_USER, user });
export const setLoadingUser = (loadingUser) => ({
  type: SET_LOADING_USER,
  loadingUser,
});
export const setUserAuthenticated = (status) => ({
  type: SET_USER_AUTHENTICATED,
  status,
});
// authState: 'checking' | 'authenticated' | 'unauthenticated'
export const setAuthState = (authState) => ({
  type: SET_AUTH_STATE,
  authState,
});
export const setUserSubscription = (subscription) => ({
  type: SET_USER_SUBSCRIPTION,
  subscription,
});
export const setMindset = (mindset) => ({ type: SET_MINDSET, mindset });
export const setLabelFilters = (labelFilters) => ({
  type: SET_LABEL_FILTERS,
  labelFilters,
});
export const setSortOrder = (sortOrder) => ({
  type: SET_SORT_ORDER,
  sortOrder,
});
export const setTaskLabels = (labels) => ({ type: SET_TASK_LABELS, labels });
export const addTaskLabel = (labelId, label) => ({
  type: ADD_TASK_LABEL,
  labelId,
  label,
});
export const updateTaskLabel = (labelId, updates) => ({
  type: UPDATE_TASK_LABEL,
  labelId,
  updates,
});
export const removeTaskLabel = (labelId) => ({
  type: REMOVE_TASK_LABEL,
  labelId,
});
export const setTaskCreationPreference = (taskCreationPreference) => ({
  type: SET_TASK_CREATION_PREFERENCE,
  taskCreationPreference,
});
